import React, { Component } from 'react';
import { AffiliateStoreMap } from 'components';

import moment from 'moment-timezone';
import styled from 'styled-components';

moment.tz.setDefault('Asia/Seoul');

const MainDiv = styled.main`
  display: flex;
  flex-direction: row;
  overflow: hidden;
  min-height: 54rem;
`;

const MapStoreDiv = styled.div`
  flex: 1;
`;

class StoreListMap extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { office, store, storeGps, listClickIdx, keyword } = this.props;

    return (
      <MainDiv>
        <MapStoreDiv>
          <AffiliateStoreMap
            keyword={keyword}
            listClickIdx={listClickIdx}
            office={office}
            stores={store}
            storeGps={storeGps}
          />
        </MapStoreDiv>
      </MainDiv>
    );
  }
}

export default StoreListMap;
